/**
 * initialsOf: the ONE initials rule for an avatar. Every screen imports it;
 * `__tests__/initials.test.ts` fails if a local copy comes back.
 *
 * The rule: the first letter of the first word and the first letter of the
 * LAST word, upper-cased ("Étienne du Plessis" is ÉP, never ÉD: the surname is
 * "du Plessis", and the first-and-second-word rule eleven local copies used
 * picked up the particle, NEW-R12-INITIALS-DISAGREE). A one-word name gives
 * its first two letters; nothing gives '?'.
 *
 * Accents: the name is normalised to composed form (NFC) first, so an "É"
 * stored as "E" plus a combining accent stays one letter, and letters are
 * taken as whole characters rather than UTF-16 halves. Leading punctuation in
 * a word ("'Johan'", "(Anna)") is skipped.
 *
 * Hoisted out of `routes/onboarding/structure-builder/mock-data.ts` on
 * 2026-07-05 (Great-Audit F-026), because real code depended on it.
 */

/** The letters of a word, from its first letter on, as whole characters. */
function lettersFrom(word: string): string[] {
  const chars = Array.from(word);
  const start = chars.findIndex((c) => /\p{L}/u.test(c));
  return start < 0 ? [] : chars.slice(start);
}

export function initialsOf(name: string | null | undefined): string {
  const words = String(name ?? '')
    .normalize('NFC')
    .trim()
    .split(/\s+/)
    .map(lettersFrom)
    .filter((w) => w.length > 0);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0]!.filter((c) => /\p{L}/u.test(c)).slice(0, 2).join('').toUpperCase();
  return (words[0]![0]! + words[words.length - 1]![0]!).toUpperCase();
}
